import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import { Color, FontSize, ShapeRadius, Spacing } from '@pushwoosh/kit-constants';
import { getBottomPosition, getLeftPosition, getRightPosition, getTopPosition, getTransform } from './tooltip.maps';
export const TooltipBox = styled(Tippy).withConfig({
  displayName: "TooltipBox",
  componentId: "sc-qluehp-0"
})(["&::after{content:\"\";position:absolute;top:", ";right:", ";bottom:", ";left:", ";width:10px;height:10px;margin:auto;border-radius:2px;background-color:", ";transform:", ";}&.tippy-box{position:static;display:block;padding:", ";color:", ";background-color:", ";border-radius:", ";font-size:", ";line-height:inherit;outline:0;transition:none;}.tippy-content{position:static;padding:0;z-index:auto;}.tippy-arrow{display:none;}"], ({
  $position,
  $arrowOffset
}) => getTopPosition($position, $arrowOffset), ({
  $position,
  $arrowOffset
}) => getRightPosition($position, $arrowOffset), ({
  $position,
  $arrowOffset
}) => getBottomPosition($position, $arrowOffset), ({
  $position,
  $arrowOffset
}) => getLeftPosition($position, $arrowOffset), Color.MAIN, ({
  $position
}) => getTransform($position), Spacing.S4, Color.CLEAR, Color.MAIN, ShapeRadius.DIALOG, FontSize.REGULAR);